export default async (pdfDocGenerator, options = {}) => {
  const {
    enablePrintButton = false,
    focusPrintButton = false,
    enterToPrint = false,
    closeOnEscape = true,
    autoPrintOnLoad = false,
    hidePreview = false,
    minimalUI = false,
    autoCloseAfterPrint = false,
  } = options;

  const createContentPDF = document.createElement("div");
  createContentPDF.id = "iframeContainer";
  createContentPDF.classList.add(
    "fixed",
    "p-4",
    "flex",
    "items-center",
    "justify-center",
    "top-0",
    "left-0",
    "w-full",
    "h-full",
    "z-50",
    ...(minimalUI ? ["bg-transparent"] : ["bg-black/60"]),
    ...(hidePreview
      ? []
      : [
          "[&>iframe]:p-10",
          "[&>iframe]:min-w-full",
          "[&>iframe]:md:min-w-[50%]",
          "[&>iframe]:min-h-[calc(100vh-2rem)]",
        ])
  );

  // Cuando es modo mínimo (sin botones) no debe bloquear clics
  if (minimalUI && !enablePrintButton) {
    createContentPDF.classList.add("pointer-events-none");
  }

  const container = document.getElementById("container-pdf");
  const cleanup = () => {
    if (!container) return;
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
  };

  // Limpia cualquier overlay previo
  cleanup();

  let keydownHandler = null;
  const printNow = () => {
    // Preferir el print nativo de pdfMake (evita problemas cross-origin del visor PDF)
    try {
      if (pdfDocGenerator && typeof pdfDocGenerator.print === "function") {
        pdfDocGenerator.print();
        if (autoCloseAfterPrint) {
          setTimeout(() => {
            cleanup();
            if (keydownHandler) document.removeEventListener("keydown", keydownHandler, true);
          }, 0);
        }
        return;
      }
    } catch (e) {
      // ignorar y probar fallback
    }

    // Fallback: intentar imprimir desde iframe si el navegador lo permite
    try {
      const iframe = document.getElementById("myIframe");
      if (!iframe) return;
      const win = iframe.contentWindow;
      if (!win) return;
      win.focus();
      win.print();
      if (autoCloseAfterPrint) {
        setTimeout(() => {
          cleanup();
          if (keydownHandler) document.removeEventListener("keydown", keydownHandler, true);
        }, 0);
      }
    } catch (e) {
      // Si está bloqueado por cross-origin, no romper el flujo
    }
  };

  if (enablePrintButton) {
    const printButton = document.createElement("button");
    printButton.classList.add(
      "absolute",
      "top-4",
      "left-4",
      "bg-blue-600",
      "px-3",
      "py-2",
      "rounded-md",
      "text-white",
      "hover:bg-blue-700",
      "flex",
      "items-center",
      "gap-2"
    );
    printButton.type = "button";
    printButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" color="currentColor">
        <path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M6 9V3h12v6"/>
        <path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
        <path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M6 14h12v7H6z"/>
      </svg>
      <span>Imprimir</span>
    `;
    printButton.addEventListener("click", () => printNow());
    createContentPDF.appendChild(printButton);

    if (focusPrintButton) {
      // el foco final se asegura cuando el iframe cargue
      setTimeout(() => printButton.focus(), 0);
    }

  }

  // Hotkeys deben funcionar incluso sin botón visible
  if (enterToPrint || closeOnEscape) {
    keydownHandler = (e) => {
      if (e.key === "Enter" && enterToPrint) {
        e.preventDefault();
        printNow();
      }
      if (e.key === "Escape" && closeOnEscape) {
        e.preventDefault();
        cleanup();
        if (keydownHandler) document.removeEventListener("keydown", keydownHandler, true);
      }
    };
    document.addEventListener("keydown", keydownHandler, true);
  }

  const button = document.createElement("button");
  button.classList.add(
    "absolute",
    "top-4",
    "right-4",
    "bg-red-500",
    "px-1",
    "py-1",
    "rounded-md",
    "text-white",
    "hover:bg-red-600"
  );
  button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="none" stroke-width="1.5" viewBox="0 0 24 24" color="currentColor"><path stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"></path></svg>`;
  if (!minimalUI) {
    createContentPDF.appendChild(button);
  }

  button.addEventListener("click", () => {
    cleanup();
    if (keydownHandler) document.removeEventListener("keydown", keydownHandler, true);
  });

  container.appendChild(createContentPDF);
  await pdfDocGenerator.getDataUrl(async (dataUrl) => {
    const targetElement = document.querySelector("#iframeContainer");
    const iframe = document.createElement("iframe");
    iframe.id = "myIframe";
    iframe.src = await dataUrl;
    if (hidePreview) {
      iframe.style.position = "fixed";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.style.opacity = "0";
      iframe.style.pointerEvents = "none";
    }
    iframe.addEventListener("load", () => {
      if (focusPrintButton) {
        const firstButton = targetElement?.querySelector("button");
        if (firstButton) firstButton.focus();
      }
      if (autoPrintOnLoad) {
        // No todos los navegadores permiten print automático; si lo bloquean,
        // queda el botón enfocado para usar Enter.
        printNow();
      }
    });
    targetElement.appendChild(iframe);
  });
};
